<template>
    <div>
        <div>
            <div class="form problem">
                <mt-field label="运单号码" class="mt-gap" placeholder="输入运单号码" v-model="search.waybillNo"></mt-field>
                <mt-field label="处理状态" placeholder="全部" v-model="showStatus" readonly
                          @click.native="popupVisible=true">
                </mt-field>
                <mt-cell title="登记日期" class="price-cell">
                    <mt-field placeholder="选择起使日期" readonly v-model="search.beginTime"
                              @click.native="openPicker"></mt-field>
                    至
                    <mt-field placeholder="选择终止日期" readonly v-model="search.endTime"
                              @click.native="openPicker2"></mt-field>
                    <img src="../../assets/date.png" alt="" class="input-icon" style="padding-right: 10px;">
                </mt-cell>
            </div>
            <div class="padded mt-gap2">
                <mt-button type="primary" style="width: 100%;" @click.native="searchData()">查询</mt-button>
            </div>
            <div
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="loading"
                    infinite-scroll-immediate-check="false"
                    infinite-scroll-distance="10">
                <div class="result" v-if="initSearch&&result.length !== 0">
                    <p class="padded" style="color: #666;">查询结果</p>
                    <div class="padded info" v-for="(item, index) in result" :key="index">
                        <div class="item">
                            <p class="fl">运单号码：{{item.waybillNo}}</p>
                            <span class="fr" style="color: #19a0ff;"
                                  @click="$router.push({name: 'ProblemDesc',query: {id: item.problemId, fromList: 1}})">详情&gt;&gt;</span>
                        </div>
                        <p>登记日期：{{dateFormat(new Date(item.regTime))}}</p>
                        <p>问题类型：{{item.problemType}}</p>
                        <p>当前状态：{{item.status}}</p>
                        <p>问题描述：</p>
                        <p class="desc">
                            {{item.problemDesc}}
                        </p>
                    </div>
                </div>
            </div>

            <div v-show="initSearch&&result.length===0">
                <p style="text-align: center;margin-top: 10px;color: #999;font-size: 14px;">没有数据</p>
            </div>
            <mt-datetime-picker
                    ref="picker"
                    v-model="datePicker"
                    type="date"
                    :startDate="startDate"
                    @confirm="handleConfirm1">
            </mt-datetime-picker>
            <mt-datetime-picker
                    ref="picker2"
                    v-model="datePicker2"
                    type="date"
                    :startDate="startDate2"
                    @confirm="handleConfirm2">
            </mt-datetime-picker>
            <mt-popup
                    style="width: 100%;"
                    v-model="popupVisible"
                    position="bottom">
                <div style="background: #fff;height: 240px;width: 100%;">
                    <div style="padding: 10px;">
                        <mt-button size="small" type="default" style="float: left;" @click="popupVisible=false">取消
                        </mt-button>
                        <mt-button size="small" type="primary" style="float: right;" @click="typeConfirm()">确定
                        </mt-button>
                    </div>
                    <mt-picker :slots="types" @change="onValuesChange"></mt-picker>
                </div>
            </mt-popup>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Problem',
        data() {
            return {
                datePicker: '',
                datePicker2: '',
                startDate: new Date(),
                startDate2: new Date(),
                loading: false,
                search: {
                    pageIndex: 1,
                    pageSize: 10,
                    waybillNo: '',
                    beginTime: '',
                    endTime: '',
                    status: ''
                },
                initSearch: false,
                result: [],
                total: '',
                popupVisible: false,
                types: [
                    {content: 'type1', values: ['全部', '未处理', '客户回复中', '处理完毕', '无需回复']},
                ],
                status: '',
                showStatus: '全部'
            }
        },
        created() {
            document.title = "问题件查询";
            var date = new Date();
            this.datePicker = date;
            this.datePicker2 = date;
            if (this.$util.get('companyNo').toUpperCase() !== 'JLTY') {
                let year = date.getFullYear() - 10;
                this.startDate = new Date(year + '-01-01');
                this.startDate2 = new Date(year + '-01-01');
            } else {
                this.startDate = new Date('2019-03-27');
                this.startDate2 = new Date('2019-03-27');
            }
            this.search.beginTime = this.dateFormat(date);
            this.search.endTime = this.dateFormat(date);
        },
        methods: {
            dateFormat(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0' + day;
                }
                return year + '-' + month + '-' + day;
            },
            openPicker() {
                this.$refs.picker.open();
            },
            openPicker2() {
                this.$refs.picker2.open();
            },
            onValuesChange(obj) {
                this.status = obj.values[0];
            },
            typeConfirm() {
                this.showStatus = this.status;
                this.search.status = this.status === '全部' ? '' : this.status;
                this.popupVisible = false;
            },
            handleConfirm1() {
                var date = this.datePicker;
                this.search.beginTime = this.dateFormat(date);
            },
            handleConfirm2() {
                var date = this.datePicker2;
                this.search.endTime = this.dateFormat(date);
            },
            searchData() {
                if (this.loading) return false;
                this.initSearch = true;
                this.result = [];
                this.getData();
            },
            getData(pageIndex = 1, pageSize = 10) {
                let start = new Date(this.search.beginTime).getTime();
                let end = new Date(this.search.endTime).getTime();
                if (end < start) {
                    this.$toast("截止时间需大于起始时间");
                    return;
                }
                if (end - start > 90 * 24 * 60 * 60 * 1000) {
                    this.$toast("查询时间跨度最多能超过90天");
                    return;
                }
                this.loading = true;
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.search.pageIndex = parseInt(pageIndex);
                this.search.pageSize = parseInt(pageSize);
                this.http.send({command: 'orderProblem/findOrderProblem', params: this.search}).then(res => {
                    this.loading = false;
                    this.$indicator.close();
                    this.total = res.data.body.totalCount;
                    this.result = this.result.concat(res.data.body.datas || []);
                }).catch(err => {
                    this.loading = false;
                    this.$indicator.close();
                })
            },
            loadMore() {
                if (this.loading) return false;
                if (this.total === this.result.length) return false;
                this.search.pageIndex++;
                this.getData(this.search.pageIndex);
            },
        }
    }
</script>
<style scoped>
    .problem >>> .mint-field-core {
        text-align: right;
    }
    .problem .price-cell >>> .mint-field-core {
        text-align: center;
    }
    .problem .price-cell {
        background-image: none;
    }
</style>
<style lang="less" scoped>
    .result {
        margin-top: 20px;
        .info {
            background: #fff;
            margin-top: 8px;
            padding-bottom: 10px;
            .item {
                line-height: 32px;
                border-bottom: 1px solid #f4f3f3;
                padding-bottom: 5px;
                padding-top: 5px;
                margin-bottom: 5px;
                overflow: hidden;

                span {
                    color: #19a0ff;
                }
            }
            p {
                line-height: 30px;
                &.desc {
                    color: #666666;
                    font-size: 14px;
                    line-height: 24px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/problem/problem.vue